import { useQuery } from '@tanstack/react-query'

import { request } from '../../../../../lib/axios'
import { QueryConfig, ExtractFnReturnType } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'

export const getMetaProtectionMode = async ({
  accountId,
  connectionId,
  adAccountId,
}: {
  accountId: number
  connectionId: number
  adAccountId: number
}): Promise<{ protectAll: boolean } | Error> => {
  return await request<{ protectAll: boolean }>({
    url: `/accounts/${accountId}/facebook/${connectionId}/ad-accounts/${adAccountId}/mode`,
    method: 'GET',
  })
}

type QueryFnType = typeof getMetaProtectionMode

export const useGetMetaProtectionMode = ({
  connectionId,
  adAccountId,
  config,
}: {
  connectionId: number
  adAccountId: number
  config?: QueryConfig<QueryFnType>
}) => {
  const { accountId } = useUserStore()
  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['getMetaProtectionMode', connectionId, adAccountId],
    queryFn: () => getMetaProtectionMode({ accountId, connectionId, adAccountId }),
    staleTime: 0,
    ...config,
  })

  const protectionData = query.data instanceof Error ? false : query.data?.protectAll

  return { ...query, data: protectionData }
}
